<template>
  <transition>
    <div v-show="!!totalServices" :class="$style.base">
      <div :class="$style.summary">
        <div :class="$style.total">{{ $t('general.total') }}:</div>
        <div
          v-if="settings.show_service_prices"
          :class="[$style.sum, { [$style.animating]: animateTotals }]"
          v-test="'services-summary-price'"
        >
          {{ currency(subTotalPrice) }}
        </div>
        <div
          v-else
          :class="[$style.sum, { [$style.animating]: animateTotals }]"
          v-test="'services-summary-services'"
        >
          {{ totalServices }}
        </div>
      </div>
      <BaseButton @click="submit" v-test="'btn-services-submit'">
        {{ $t('services.button_submit') }}
      </BaseButton>
    </div>
  </transition>
</template>

<script setup lang="ts">
import BaseButton from '@/components/BaseButton.vue';
import { currency } from '@/helpers';
import { useBookingStore } from '@/stores/booking';
import { useCompanyStore } from '@/stores/company';
import { storeToRefs } from 'pinia';
import { computed, ref, watch } from 'vue';
import { inject } from 'vue';

const emit = defineEmits(['submit']);
const gtag = inject<any>('gtag');
const { settings } = useCompanyStore();
const { subTotalPrice, serviceIds } = storeToRefs(useBookingStore());
const totalServices = computed(() => serviceIds.value.length);

watch([subTotalPrice, totalServices], () => {
  animateTotals.value = false;
  setTimeout(() => {
    animateTotals.value = true;
  }, 10);
});

const animateTotals = ref(false);

const submit = () => {
  emit('submit');
  gtag.trackEvent('service_confirm');
};
</script>

<style lang="scss" module>
.base {
  padding: $spacing;
  background-color: white;
  @include box-shadow('large', 'top');
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  &:global(.v-enter-active) {
    position: absolute;
    left: 0;
    bottom: 0;
    transition: transform 0.15s ease-out;
  }

  &:global(.v-enter-from) {
    transform: translateY(100%);
  }
}

.summary {
  margin-right: $spacing;
}

.total {
  margin-bottom: 5px;
  font-size: 12px;
}

.sum {
  font-weight: bold;
  font-size: 24px;

  &.animating {
    animation: scale $easing 0.2s 1;
  }
}

@keyframes scale {
  0%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.15);
  }
}
</style>
